<template>
    <label :class="classes">
        <input :id="`field-${name}-input`"
               :name="name"
               :aria-labelledby="`field-${name}-label`"
               :value="value"
               @input="updateValue"
               :placeholder="placeholder"
               class="field-input"
               type="file"
               :multiple="multiple"
               :accept="accept"
               ref="input"
        >
        <span :id="`field-${name}-label`"
              class="field-label"
              aria-hidden="true"
              v-if="label">
            {{ label }}
        </span>
    </label>
</template>

<script>
  import BaseField from './BaseField';

  export default {
    name: 'FileField',

    extends: BaseField,

    props: {
      multiple: {
        type:    Boolean,
        default: false,
      },

      accept: {
        type:    String,
        default: '*/*',
      },
    },

    computed: {
      classes () {
        return {
          ...this.baseClasses,
          'field-type-interactive': true,
          'field-type-file':        true,
        };
      },
    },

    methods: {
      updateValue ( event ) {
        this.$emit('input', event.target.value);
        this.$emit('blob', this.getBlob());
      },

      /**
       * Retrieves the file as a blob
       *
       * @return {File}
       */
      getBlob () {
        console.log(this.$refs);
        return this.$refs.input.files.item(0);
      },
    },
  };
</script>

<style scoped>

</style>
